import { useEffect, useRef } from "react";

/** Sluit een dialog/viewer met de hardware/browser terug-knop (mobiel & iPad-vriendelijk).
 *  StrictMode-proof: double-mount van effects plant/annuleert de history-correctie via een ref-timer.
 *  Gebruik: useBackClose(open, () => setOpen(false)); */
export function useBackClose(open, close) {
  const closeRef = useRef(close);
  closeRef.current = close;
  const idRef = useRef(`bpt-${Math.random().toString(36).slice(2)}`);
  const backTimer = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    if (backTimer.current) {
      // StrictMode re-run: geplande back() annuleren, onze history-entry staat er nog
      clearTimeout(backTimer.current);
      backTimer.current = null;
    } else {
      window.history.pushState({ bptDialoog: idRef.current }, "");
    }
    let dicht = false;
    const onPop = (e) => {
      if (dicht) return;
      // Als de nieuwe top-state van óns is, werd een dialog bóven ons gesloten — niet reageren
      if (e.state?.bptDialoog === idRef.current) return;
      dicht = true;
      closeRef.current();
    };
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      if (!dicht) {
        // Dialog via X/knop gesloten: verwijder onze history-entry, maar async zodat een
        // StrictMode effect-re-run dit kan annuleren
        backTimer.current = setTimeout(() => {
          backTimer.current = null;
          if (window.history.state?.bptDialoog === idRef.current) window.history.back();
        }, 60);
      }
    };
  }, [open]);
}
